import { withStyles } from "@material-ui/core";
import React from "react";
import Message from "./Message";
import Dropdown from "../../../../../../common/Dropdown";
import { getDriverStatus } from "../../../utils/DriverStatus";
import DriverImage from "./DriverImage";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  driverImg: {
    width: "70%",
    height: "70%",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "50%",
    color: theme.dividerColor,
  },
  imgStyle: {
    maxWidth: "70%",
  },
  driverListDropdown: {
    display: "flex",
    width: 130,
    alignItems: "center",
  },
  driverName: {
    margin: 0,
    padding: 0,
    fontSize: "16px",
    lineHeight: "25px",
    marginTop: 8,
    color: theme.HeaderSelectedText,
  },
  paddingRight: {
    paddingRight: 10,
  },
  statusContainer: {
    marginTop: 8,
    display: "flex",
    flexWrap: "wrap",
  },
  statusLabel: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    fontWeight: 500,
    marginRight: 8,
  },
  statusValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    fontWeight: 600,
    marginRight: 48,
  },
});
const DriverInfo = ({
  classes,
  driverInfo,
  onMsgClick,
  changeSelectedDriver,
  dispatchedDriversList,
  terminalOffset,
  driverImage,
}) => {
  return (
    <div className={classes.container}>
      <DriverImage
        driverImage={driverImage}
        customStyle={{
          driverImg: classes.driverImg,
          imgStyle: classes.imgStyle
        }}
      />
      <div>
        <div className={classes.driverListDropdown}>
          <Dropdown
            placeholder="Select driver"
            value={driverInfo.driverId ?? null}
            options={dispatchedDriversList}
            onChange={changeSelectedDriver}
            customReactSelectClass={classes.paddingRight}
          />
          <Message onClick={onMsgClick} />
        </div>
        <div className={classes.driverName}>{driverInfo.driverName}</div>
        <div className={classes.statusContainer}>
          <span className={classes.statusLabel}>Current Status :</span>
          <span className={classes.statusValue}>
            {getDriverStatus({ data: driverInfo, context: terminalOffset })}
          </span>
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(DriverInfo);
